/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

export const googleMapsKey = 'AIzaSyAnWJSarkqgNTx5ocG3PjsFUKrCNCuAnaQ';
export const autoUpdate = true;
export const baiduMap = false;
export const i18nBackendLoadPath = '/locales/{{lng}}/{{ns}}.json';
export const baseURL = 'https://backend.uat.soundtalksweb.com';
export const captchaKey = '0x4AAAAAAAJ4bXXC5KepQkYz';
export const reversedFullName = false;
export const apkDownloadUrl = null;
export const isChinaConfig = false;
export const isDemo = false;
export const enableSubscription = false;
export const wechatAppId = 'wx6754d7df320c7e03';
// Allowed domains for pre-signed download URLs
export const allowedDownloadDomains = [
  'soundtalks-uat-s3-backend-batch-exports.s3.eu-west-1.amazonaws.com', // Batch exports
  'd17tjf7tna6jmq.cloudfront.net', // Audio snippets
];

export const themeColors = {
  '--st-color-ai': '#00263A',
};
